import { HTMLAttributes } from 'react'

import { cn } from '../../lib/utils'

type DataChipProps = HTMLAttributes<HTMLDivElement> & {
  icon?: React.ReactNode
  label: string
}

export function DataChip({ className, icon, label, ...props }: DataChipProps) {
  return (
    <div
      className={cn(
        'bg-kinetic-surface-container-highest/70 border-kinetic-outline-variant/30 inline-flex items-center gap-2 border px-3 py-1',
        className
      )}
      {...props}
    >
      {icon ? <span className="text-kinetic-primary-container">{icon}</span> : null}
      <span className="font-mono text-[10px] tracking-[0.28em] text-kinetic-primary-container">
        {label}
      </span>
    </div>
  )
}
